// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__25ofx","subheader":"ReorderModal_subheader__24KVI","listWrap":"ReorderModal_listWrap__37pDs"};